<template>
  <b-dropdown class="d-inline-flex mx-1" size="sm" text="efficiency">
    <div class="scrollable">
      <b-list-group>
        <template v-for="kiddo,kidid in node.children">
          <b-list-group-item class="nowrap" disabled :key=kiddo.id>
            <div class="flex-row">
              <span class="symbol" v-if="auth" style="cursor:pointer" @click="e=>{edit(kiddo.waste_percentage,kidid,'value')}">&#x270E;</span>
              <b>{{kiddo.name}}: </b>
              <em v-if="!edit_str.length || edit_str!='value'" v-model="edit_content">{{kiddo.waste_percentage}}</em>
              <input v-else v-focus @keyup.enter="done" @blur="done" v-model="edit_content">
              <em>waste</em>
            </div>
            <div class="flex-row">
              <span class="symbol" v-if="auth" style="cursor:pointer" @click="e=>{edit(kiddo.waste_reference,kidid,'reference')}">&#x270E;</span>

            <template v-if="!edit_str.length || edit_str!='reference'"><a v-if="kiddo.waste_reference.length"  class="linkref"  :href="kiddo.waste_reference" target="_blank">{{kiddo.waste_reference}}</a> <em v-else class="linkref">(add reference...)</em></template>
            <input v-else class="linkref edit" v-focus @blur="done" @keyup.enter="done" v-model="edit_content">
            </div>
          </b-list-group-item>
          </template>
      </b-list-group>
    </div>
  </b-dropdown>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Vue from 'vue'

  import * as d3 from 'd3'

  import utils from '../utils'

  const focus = {
  inserted(el) {
  el.focus()
  },
  }

  export default {
  name:'Efficiency',
  props: ['node','name'],
  components: {},
  data () {
  return {
  edit_str:"",
  edit_store:"",
  edit_content:"",
  edit_id:null
    }
  },
  directives: { focus },
  computed:{
  ...mapState({
  auth: state => state.backend.isAuthenticated,
      sigfig: state => state.sigfig+1
    }),
  },

  methods:{
  edit(t,id,str){
  this.edit_store = t
  this.edit_content = t
  this.edit_id = id
  this.edit_str = str
  },

  done(){
  if(this.edit_id == null)
  return





  if(this.edit_str=="value"){
  if (!isNaN(parseFloat(this.edit_content)) && isFinite(this.edit_content)){
  var val = Math.min(Math.max(this.edit_content,0.),1.)
  this.$store.commit("modify_efficiency",{node:this.node.children[this.edit_id],value:val})
  }
  }else{
  console.log(this.node.children, ' ' , this.edit_id)
  this.node.children[this.edit_id].waste_reference=this.edit_content
  this.$store.commit("set_dirty",true)
  }

  this.edit_store=""
  this.edit_content=""
  this.edit_str=""
  this.edit_id=null

  },
  clickout(e){
  this.done()
  }
  }
  }
</script>

<style scoped>

.dropdown >>> .show {
      padding-top:0px;
      padding-bottom:0px;
}

.nowrap{
    white-space: nowrap;
    padding:5px;
}

.scrollable{
    height:auto;
    max-height:450px;
    overflow-y: auto;
}

.linkref{
    font-size:11px;
}

.symbol{
    font-size:12px;
}

.edit{
    width:100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Efficiency.vue